<template>
    <div v-if="modalVisible" id="static-hold-modal" class="modal fade waitingmodal show" tabindex="-1" style="display: block; z-index: 1050;" data-backdrop="static" data-keyboard="false" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content custom-loader">
                <div class="modal-body py-0 text-center">
                    <img src="/assets/img/loader.gif" alt="loading modal gif">
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import eventBus from '../plugins/eventBus'
export default {
    name:   'WaitingModal',
    
    data()
    {
        return{
            modalVisible: false
        }
    },

    methods: 
    {
        hideModal() 
        {
            this.modalVisible = false;
        },

        showModal() 
        {
            this.modalVisible = true;
        },
    },

    async created()
    {
        eventBus.$on('hideModal', () => 
        {
            this.hideModal()
        })

        eventBus.$on('showModal', () => 
        {
            setTimeout(() => 
            {
                this.showModal()
            }, 0);
        })
    }
}
</script>